import ValidService from "../../../service/ValidService";
let model = {};

model.dataForm = {
    id: null, // optional
    ho_ten: null, // required tên ng đăng ký quảng cáo
    email: null, // required, pattern: /^([\w\.\-]+)@([\w\-]+)((\.(\w){2,3})+)$/ email
    ten_cong_ty: null, // required tên cty đăng ký quảng cáo
    sdt: null, // optional tên cty đăng ký quảng cáo
    phong_ban: null, // optional tên cty đăng ký quảng cáo
    noi_dung: null, // optional tên cty đăng ký quảng cáo
    xu_ly: null, // required
}

model.trangThai = [

    {
        code: true,
        text: "Đã xử lý"
    },
    {
        code: false,
        text: "Chưa xử lý"
    },
];

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            ho_ten: "",
            sdt: "",
            email: "",
            xu_ly: ""
        },
        valid: {
            ho_ten: [],
            sdt: [],
            email: [],
            xu_ly: []
        },
        operator: {
            ho_ten: "$vn_text=", //:regex:, $vn_text=Viêt nam
            sdt: ":regex:",
            email: ":regex:",
            xu_ly: ""
        }
    }
};

export default model;